const DataSource_reactDevtoolsBridge = 'react-devtools-bridge';
export const Filtered_Sources = [DataSource_reactDevtoolsBridge, 'react-devtools-content-script', 'react-devtools-backend-manager'];
//actions
export const EpicAction_InitiateHandshake = 'Epic.Clinical.Informatics.Web.InitiateHandshake';
export const EpicAction_PostOrder = 'Epic.Clinical.Informatics.Web.PostOrder';
export const EpicAction_PostProtocol = 'Epic.Clinical.Informatics.Web.PostProtocol';
export const EpicAction_CloseAppResponse = 'Epic.Common.CloseAppResponse';
export const EpicAction_CloseActivityRequest = 'Epic.Clinical.Informatics.Web.CloseActivity';
//events
export const EpicEvent_RequestToCloseApp = 'Epic.Common.RequestToCloseApp';
//# sourceMappingURL=consts.js.map